import type { RouteRecordRaw } from 'vue-router';

export const surveyRoutes: Array<RouteRecordRaw> = [
  {
    path: '/survey',
    name: 'survey',
    redirect: '/survey/project/list',
    component: () => import('pages/micros/survey/project/SurveyProject.vue'),
    meta: {
      title: 'Surveys Service - for private & public surveys',
      requiresAuth: true,
    },
    children: [],
  },
  {
    path: '/survey/project',
    name: 'surveyProject',
    redirect: '/survey/project/list',
    component: () => import('pages/micros/survey/project/SurveyProject.vue'),
    meta: {
      title: 'Survey Projects - for private & public surveys',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyProjectList',
        component: () => import('pages/micros/survey/project/SurveyList.vue'),
        meta: {
          title: 'Survey Projects List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyProjectDetail',
        component: () => import('pages/micros/survey/project/SurveyDetail.vue'),
        meta: {
          title: 'Support Project Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyProjectNew',
        component: () => import('pages/micros/survey/project/SurveyNew.vue'),
        meta: {
          title: 'New Survey Project',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/access',
    name: 'surveyAccess',
    redirect: '/survey/access/list',
    component: () => import('pages/micros/survey/access/SurveyAccess.vue'),
    meta: {
      title: 'Survey access assignment for private surveys',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyAccessList',
        component: () => import('pages/micros/survey/access/SurveyAccessList.vue'),
        meta: {
          title: 'Survey Accesses List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyAccessDetail',
        component: () => import('pages/micros/survey/access/SurveyAccessDetail.vue'),
        meta: {
          title: 'Survey Access Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyAccessNew',
        component: () => import('pages/micros/survey/access/SurveyAccessNew.vue'),
        meta: {
          title: 'New Survey Access',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/category',
    name: 'surveyCategory',
    redirect: '/survey/category/list',
    component: () => import('pages/micros/survey/category/SurveyCategory.vue'),
    meta: {
      title: 'Survey Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyCategoryList',
        component: () => import('pages/micros/survey/category/SurveyCategoryList.vue'),
        meta: {
          title: 'Survey Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyCategoryDetail',
        component: () => import('pages/micros/survey/category/SurveyCategoryDetail.vue'),
        meta: {
          title: 'Survey Category Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyCategoryNew',
        component: () => import('pages/micros/survey/category/SurveyCategoryNew.vue'),
        meta: {
          title: 'New Survey Category',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/question',
    name: 'surveyQuestion',
    redirect: '/survey/question/list',
    component: () => import('pages/micros/survey/question/SurveyQuestion.vue'),
    meta: {
      title: 'Survey Questions',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyQuestionList',
        component: () => import('pages/micros/survey/question/SurveyQuestionList.vue'),
        meta: {
          title: 'Comments List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyQuestionDetail',
        component: () => import('pages/micros/survey/question/SurveyQuestionDetail.vue'),
        meta: {
          title: 'Survey Question Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyQuestionNew',
        component: () => import('pages/micros/survey/question/SurveyQuestionNew.vue'),
        meta: {
          title: 'New Survey Question',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/answer',
    name: 'surveyAnswer',
    redirect: '/survey/answer/list',
    component: () => import('pages/micros/survey/answer/SurveyAnswer.vue'),
    meta: {
      title: 'Survey Answers / Expectations',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyAnswerList',
        component: () => import('pages/micros/survey/answer/SurveyAnswerList.vue'),
        meta: {
          title: 'Survey Answers / Expectations List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyAnswerDetail',
        component: () => import('pages/micros/survey/answer/SurveyAnswerDetail.vue'),
        meta: {
          title: 'Survey Answer / Expectation Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyAnswerNew',
        component: () => import('pages/micros/survey/answer/SurveyAnswerNew.vue'),
        meta: {
          title: 'New Survey Answer / Expectation',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/responder',
    name: 'surveyResponder',
    redirect: '/survey/responder/list',
    component: () => import('pages/micros/survey/responder/SurveyResponder.vue'),
    meta: {
      title: 'Survey Responders to the survey questions',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyResponderList',
        component: () => import('pages/micros/survey/responder/SurveyResponderList.vue'),
        meta: {
          title: 'Survey Responders List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyResponderDetail',
        component: () => import('pages/micros/survey/responder/SurveyResponderDetail.vue'),
        meta: {
          title: 'Survey Responder Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyResponderNew',
        component: () => import('pages/micros/survey/responder/SurveyResponderNew.vue'),
        meta: {
          title: 'New Survey Responder',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/response',
    name: 'surveyResponse',
    redirect: '/survey/response/list',
    component: () => import('pages/micros/survey/response/SurveyResponse.vue'),
    meta: {
      title: 'Survey Responses to the survey questions',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyResponseList',
        component: () => import('pages/micros/survey/response/SurveyResponseList.vue'),
        meta: {
          title: 'Survey Responses List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyResponseDetail',
        component: () => import('pages/micros/survey/response/SurveyResponseDetail.vue'),
        meta: {
          title: 'Survey Response Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyResponseNew',
        component: () => import('pages/micros/survey/response/SurveyResponseNew.vue'),
        meta: {
          title: 'New Survey Response',
          requiresAuth: true,
        },
      },
      {
        path: 'wizard/:itemId?',
        name: 'surveyResponseExplorer',
        component: () => import('pages/micros/survey/response/SurveyResponseExplorer.vue'),
        meta: {
          title: 'Survey Vote Response Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'result/:itemId?',
        name: 'surveyResponseResult',
        component: () => import('pages/micros/survey/response/SurveyResponseResult.vue'),
        meta: {
          title: 'Survey Vote Response Result',
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/survey/vote',
    name: 'surveyVote',
    redirect: '/survey/vote/list',
    component: () => import('pages/micros/survey/vote/SurveyVote.vue'),
    meta: {
      title: 'Survey voting',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyVoteList',
        component: () => import('pages/micros/survey/vote/VoteList.vue'),
        meta: {
          title: 'Survey Votes List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyVoteDetail',
        component: () => import('pages/micros/survey/vote/VoteDetail.vue'),
        meta: {
          title: 'Survey Vote Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyVoteNew',
        component: () => import('pages/micros/survey/vote/VoteNew.vue'),
        meta: {
          title: 'New Survey Vote',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'surveyVoteExplorer',
        component: () => import('pages/micros/survey/vote/VoteExplorer.vue'),
        meta: {
          title: 'Survey Votes Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'view/:itemId?',
        name: 'surveyVoteView',
        component: () => import('pages/micros/survey/vote/VoteView.vue'),
        meta: {
          title: 'Survey Vote View',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/stat',
    name: 'surveyStat',
    redirect: '/survey/stat/list',
    component: () => import('pages/micros/survey/stat/VoteStat.vue'),
    meta: {
      title: 'Survey voting stats',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyStatList',
        component: () => import('pages/micros/survey/stat/StatList.vue'),
        meta: {
          title: 'Survey Voting Stats List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyStatDetail',
        component: () => import('pages/micros/survey/stat/StatDetail.vue'),
        meta: {
          title: 'Survey Voting Stat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyStatNew',
        component: () => import('pages/micros/survey/stat/StatNew.vue'),
        meta: {
          title: 'New Survey Stat',
          requiresAuth: true,
        },
      },
    ],
  },

  {
    path: '/survey/comment',
    name: 'surveyComment',
    redirect: '/survey/comment/list',
    component: () => import('pages/micros/survey/comment/SurveyComment.vue'),
    meta: {
      title: 'Information Comments - for product items...',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyCommentList',
        component: () => import('pages/micros/survey/comment/CommentList.vue'),
        meta: {
          title: 'Comments List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyCommentDetail',
        component: () => import('pages/micros/survey/comment/CommentDetail.vue'),
        meta: {
          title: 'Comment Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyCommentNew',
        component: () => import('pages/micros/survey/comment/CommentNew.vue'),
        meta: {
          title: 'New Comment',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/list',
        name: 'surveyCommentStatList',
        component: () => import('pages/micros/survey/commentStat/CommentStatList.vue'),
        meta: {
          title: 'Comment Stats List',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/detail/:itemId?',
        name: 'surveyCommentStatDetail',
        component: () => import('pages/micros/survey/commentStat/CommentStatDetail.vue'),
        meta: {
          title: 'Comment Stat Details',
          requiresAuth: true,
        },
      },
      {
        path: 'stat/new',
        name: 'surveyCommentStatNew',
        component: () => import('pages/micros/survey/commentStat/CommentStatNew.vue'),
        meta: {
          title: 'New Comment Stat',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/rate',
    name: 'surveyRate',
    redirect: '/survey/rate/list',
    component: () => import('pages/micros/survey/rate/SurveyRate.vue'),
    meta: {
      title: 'Rates - internal P2P, P2/Group | internet - P2P',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyRateList',
        component: () => import('pages/micros/survey/rate/RateList.vue'),
        meta: {
          title: 'Rates List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyRateDetail',
        component: () => import('pages/micros/survey/rate/RateDetail.vue'),
        meta: {
          title: 'Rate Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyRateNew',
        component: () => import('pages/micros/survey/rate/RateNew.vue'),
        meta: {
          title: 'New Rate',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/rating',
    name: 'surveyRating',
    redirect: '/survey/rating/list',
    component: () => import('pages/micros/survey/rating/SurveyRating.vue'),
    meta: {
      title: 'Ratings by Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyRatingList',
        component: () => import('pages/micros/survey/rating/RatingList.vue'),
        meta: {
          title: 'Ratings List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'surveyRatingDetail',
        component: () => import('pages/micros/survey/rating/RatingDetail.vue'),
        meta: {
          title: 'Rating Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'surveyRatingNew',
        component: () => import('pages/micros/survey/rating/RatingNew.vue'),
        meta: {
          title: 'New Rating',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/view',
    name: 'surveyView',
    redirect: '/survey/view/list',
    component: () => import('pages/micros/survey/view/SurveyView.vue'),
    meta: {
      title: 'Views - page views',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyViewList',
        component: () => import('pages/micros/survey/view/ViewList.vue'),
        meta: {
          title: 'Views List',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/share',
    name: 'surveyShare',
    redirect: '/survey/share/list',
    component: () => import('pages/micros/survey/view/SurveyView.vue'),
    meta: {
      title: 'Shares - page shared with others',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'surveyShareList',
        component: () => import('pages/micros/survey/view/ShareList.vue'),
        meta: {
          title: 'Shares List',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/survey/bookmark',
    name: 'surveyBookmark',
    redirect: '/survey/bookmark/list',
    component: () => import('pages/micros/survey/bookmark/SurveyBookmark.vue'),
    meta: {
      title: 'Information Bookmarks - for information products...',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'surveyBookmarkList',
        component: () => import('pages/micros/survey/bookmark/BookmarkList.vue'),
        meta: {
          title: 'Bookmarks List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'surveyBookmarkDetail',
        component: () => import('pages/micros/survey/bookmark/BookmarkDetail.vue'),
        meta: {
          title: 'Bookmark Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'surveyBookmarkNew',
        component: () => import('pages/micros/survey/bookmark/BookmarkNew.vue'),
        meta: {
          title: 'New Bookmark',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer/:bookCategory?/:bookName?/:bookUrl?/:bookId?/:callingPageName?/:path?',
        name: 'surveyBookmarkExplorer',
        component: () => import('pages/micros/survey/bookmark/BookmarkExplorer.vue'),
        meta: {
          title: 'Bookmarks Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
